<script>
import ListNotificationsByAccountComponent from '../../features/Lists/ListNotificationsByAccountComponent';

export default {
  extends: ListNotificationsByAccountComponent,
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
<template>
  <!-- Body Start -->
  <div class="wrapper">
    <div class="sa4d25">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <h2 class="st_title">
              <i class="uil uil-bell" /> Notificaciones
            </h2>
          </div>
        </div>
        <div
          v-loading="isListLoading"
          class="row"
          element-loading-spinner="el-icon-loading"
          :element-loading-text="listLoadingMessage"
        >
          <div class="col-12">
            <!-- <a href="#" class="setting_noti">Notification Setting</a> -->
            <div class="all_msg_bg">
              <div
                v-for="notification in collection"
                :key="notification.id"
                class="channel_my item all__noti5"
              >
                <div class="profile_link">
                  <img
                    :src="mapImage(notification.sender)"
                    alt=""
                  >
                  <div class="pd_content">
                    <h6>{{ notification.header }}</h6>
                    <p class="noti__text5">
                      {{ notification.message }}.
                      <strong v-if="notification.url">
                        <el-button
                          link
                          class="notification-view-more"
                          @click="onSelectNotification(notification)"
                        >Mostrar...</el-button></strong>
                    </p>
                    <el-tag
                      v-if="!notification.isRead"
                      size="small"
                      type="info"
                      effect="plain"
                    >
                      Nuevo
                    </el-tag>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-pagination
          v-model:current-page="currentPage"
          size="small"
          layout="prev, pager, next"
          :page-count="pagination.totalPages"
          @current-change="onPageChange"
        />
      </div>
    </div>
  </div>
  <!-- Body End -->
</template>
